import React, { FC, ReactNode } from 'react';
import { extractLogErrorIdFromError, HttpStatus, isRequestError } from '@app/libs/request';

interface PageErrorProps {
  dataTestId: string;
  children: ReactNode;
}

export const PageError: FC<PageErrorProps> = ({ dataTestId, children }) => (
  <div className='text-destructive' data-testid={dataTestId}>
    {children}
  </div>
);

interface LoadErrorProps {
  error: unknown;
  message: string;
  dataTestId: string;
}

export const LoadError: FC<LoadErrorProps> = ({ error, message, dataTestId }) => {
  if (isRequestError(error) && error.code === HttpStatus.forbidden) {
    return <PageError dataTestId={dataTestId}>You don’t have access to this page.</PageError>;
  }

  const errorCode = extractLogErrorIdFromError(error);

  return (
    <PageError dataTestId={dataTestId}>
      {message}
      {errorCode && ` Error code: ${errorCode}`}
    </PageError>
  );
};
